import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8535 2.14645C12.7598 2.05268 12.6326 2 12.5 2H11.5C11.3674 2 11.2402 2.05268 11.1464 2.14645C11.0527 2.24021 11 2.36739 11 2.5V18.67L6.55997 14.22C6.51435 14.1734 6.4599 14.1364 6.3998 14.1112C6.3397 14.0859 6.27516 14.0729 6.20997 14.0729C6.14478 14.0729 6.08025 14.0859 6.02015 14.1112C5.96005 14.1364 5.9056 14.1734 5.85997 14.22L5.14997 14.93C5.10311 14.9765 5.06591 15.0318 5.04053 15.0927C5.01514 15.1536 5.00208 15.219 5.00208 15.285C5.00208 15.351 5.01514 15.4164 5.04053 15.4773C5.06591 15.5382 5.10311 15.5935 5.14997 15.64L11.28 21.78C11.4217 21.9189 11.6116 21.9977 11.81 22H12.19C12.3888 21.9998 12.5795 21.9207 12.72 21.78L18.85 15.64C18.8968 15.5935 18.934 15.5382 18.9594 15.4773C18.9848 15.4164 18.9979 15.351 18.9979 15.285C18.9979 15.219 18.9848 15.1536 18.9594 15.0927C18.934 15.0318 18.8968 14.9765 18.85 14.93L18.15 14.22C18.1035 14.1731 18.0482 14.1359 17.9873 14.1106C17.9263 14.0852 17.861 14.0721 17.795 14.0721C17.729 14.0721 17.6636 14.0852 17.6027 14.1106C17.5418 14.1359 17.4865 14.1731 17.44 14.22L13 18.67V2.5C13 2.36739 12.9473 2.24021 12.8535 2.14645Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgDownwardOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgDownwardOutline;
